import { getRPSOCRAgreementType } from '../../flows/front-office/ocr-flows/utils';
import { isRPSOCRTraditionalAccount } from '../../flows/front-office/shared/utils';
import { accountTypes } from '../../flows/shared/utils';

export const toggleExistingAgreements = (
  fundChosen,
  agreementNumber,
  selectedFunds,
  setSelectedFunds
) => {
  const selectedFund = fundChosen;
  // check if the fund is already selected
  const isSelectedFund = selectedFunds.some(
    fund => fund?.agreementKey?.agreementNumber === agreementNumber
  );

  // if the fund already exists, remove it from selected funds state
  // else add the selected fund to the selected funds state
  return setSelectedFunds(
    isSelectedFund
      ? selectedFunds.filter(
          fund => fund?.agreementKey?.agreementNumber !== agreementNumber
        )
      : [...selectedFunds, selectedFund]
  );
};

export const shouldValidateExistingAgreementsSection = (
  editExistingAgreements,
  existingAgreementsValid
) => editExistingAgreements || existingAgreementsValid;

export const checkDuplicateFunds = (
  fundAgreementNumber,
  ticker,
  existingFundAgreements,
  selectedExistingAgreements
) => {
  // filter duplicate existing agreements based on the selected ticker
  const duplicateExistingAgreements = existingFundAgreements?.filter(
    agreement => {
      return selectedExistingAgreements?.some(
        selectedFund =>
          selectedFund?.ticker === agreement?.ticker &&
          selectedFund?.ticker === ticker
      );
    }
  );
  // returns false if there are no duplicate agreements
  if (duplicateExistingAgreements?.length <= 1) {
    return false;
  }
  // array which holds the selected agreement numbers
  const selectedFundAgreements = selectedExistingAgreements?.map(
    ({ agreementKey: { agreementNumber } }) => agreementNumber
  );
  // returns false only if the agreement number is part of the selected agreement numbers
  return duplicateExistingAgreements?.some(
    () => !selectedFundAgreements.includes(fundAgreementNumber)
  );
};

// get radio button title's for OCR existing agreements section
// based on the account type
// Based on the flow user is in -
// First Radio button Title can be Traditional IRA OR Roth IRA
// Second Radio button Title can be Traditional Rollover IRA OR Roth Rollover IRA
export const getOCRExistingAgreementTitle = accountType => {
  const isOCRTraditionalAcc = isRPSOCRTraditionalAccount(accountType);
  return `${isOCRTraditionalAcc ? 'Traditional ' : 'Roth '}`;
};

// get first radio button value for OCR existing agreements section
// based on the account type
// Based on the flow user is in -
// For Traditional Existing Agreements value needs to be TRADITIONAL_IRA
// For Roth Existing Agreements value needs to be ROTH_IRA
export const getOCRExistingAgreeValue = accountType => {
  const isOCRTraditionalAcc = isRPSOCRTraditionalAccount(accountType);
  return `${
    isOCRTraditionalAcc ? accountTypes.TRADITIONAL : accountTypes.ROTH
  }`;
};

// get second radio button value for OCR existing agreements section
// based on the account type
// Based on the flow user is in -
// For Traditional Rollover Existing Agreements value needs to be ROLLOVER_IRA
// For Roth Rollover Existing Agreements value needs to be ROTH_ROLLOVER_IRA
export const getOCRExistingAgreeRolloverValue = accountType => {
  const isOCRTraditionalAcc = isRPSOCRTraditionalAccount(accountType);
  return `${
    isOCRTraditionalAcc ? accountTypes.ROLLOVER : accountTypes.ROTH_ROLLOVER
  }`;
};

// Filter exisiting agreement array based on the agreement type being chosen
// ex: if Traditional Rollover IRA is checked then filter only existing ROLLOVER_IRA
//     agreements from existing agreements array
export const getMatchingExistingAgreeArray = (
  existingAgreementsArr,
  agreement
) => {
  return existingAgreementsArr.filter(
    ({ agreementType }) => agreement === `${agreementType}`
  );
};

// Filter Existing Agreements Array for Traditional and Roth OCR flow
// Ex: When user is in ROTH OCR flow then filter existing agreements for
//     ROTH_IRA and ROTH_ROLLVER_IRA and load them as two seperate arrays.
//     This helps if the radio button needs to be disabled if any of them
//     have length as zero and also helps in displaying as check box options
//     when respective existing account radio button is selected
export const filterExistingAgreementsType = (
  existingAgreementsArr,
  accountType
) => {
  const ocrAgreementTypes = getRPSOCRAgreementType(accountType);
  let accTypeAgreeArr = [];
  let matchingRolloverAgreeArr = [];
  if (ocrAgreementTypes.includes(accountTypes.TRADITIONAL)) {
    accTypeAgreeArr = getMatchingExistingAgreeArray(
      existingAgreementsArr,
      accountTypes.TRADITIONAL
    );
    matchingRolloverAgreeArr = getMatchingExistingAgreeArray(
      existingAgreementsArr,
      accountTypes.ROLLOVER
    );
  } else if (ocrAgreementTypes.includes(accountTypes.ROTH)) {
    accTypeAgreeArr = getMatchingExistingAgreeArray(
      existingAgreementsArr,
      accountTypes.ROTH
    );
    matchingRolloverAgreeArr = getMatchingExistingAgreeArray(
      existingAgreementsArr,
      accountTypes.ROTH_ROLLOVER
    );
  }
  return [accTypeAgreeArr, matchingRolloverAgreeArr];
};
